export const DEFAULT_ENABLED_LANGUAGE_CODES = ['zh-cn', 'en']

export const SUPPORTED_LANGUAGE_CODES = [
  'zh-cn', 'en', 'fr', 'pt', 'es', 'pl', 'de', 'it', 'tr'
]

export function normalizeEnabledLanguages(enabled) {
  if (!Array.isArray(enabled)) return [...DEFAULT_ENABLED_LANGUAGE_CODES]
  const codes = enabled
    .map((code) => String(code))
    .filter((code) => SUPPORTED_LANGUAGE_CODES.includes(code))
  return codes.length ? codes : [...DEFAULT_ENABLED_LANGUAGE_CODES]
}

export function applyEnabledLanguages(vm, enabled) {
  const codes = normalizeEnabledLanguages(enabled)
  vm.enabledLanguageCodes = codes

  const current = localStorage.getItem('selected_language') || vm.$i18n?.locale
  if (current && !codes.includes(current)) {
    const fallback = codes.includes('en') ? 'en' : codes[0]
    localStorage.setItem('selected_language', fallback)
    if (vm.$i18n) vm.$i18n.locale = fallback
    if ('selectedLanguage' in vm) vm.selectedLanguage = fallback
    if ('currentLanguage' in vm) vm.currentLanguage = fallback
  }
}
